import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setLanguage } from '../language/store';

type Props = {
  testID?: string;
};

export const LangSwitcher: React.FC<Props> = ({ testID = 'LangSwitcher' }) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const updateLng = useCallback(
    (lang: string) => () => {
      dispatch(setLanguage({ lang }));
      i18n.changeLanguage(lang);
    },
    [i18n, dispatch],
  );

  return (
    <div
      data-testid={testID}
      className="md:fixed py-2 px-4 bg-primary rounded-sm z-50 bottom-0 my-1 mx-2 hidden md:block"
    >
      <ul className="flex flex-row justify-center md:justify-start">
        <li className="mx-2">
          <a
            onClick={updateLng('fr')}
            className={`${i18n.language === 'fr' ? 'text-primary ' : 'hover:opacity-60 cursor-pointer'} `}
          >
            Français
          </a>
        </li>
        <li className="mx-2">
          <a
            onClick={updateLng('en')}
            className={`${i18n.language === 'en' ? 'text-primary ' : 'hover:opacity-60 cursor-pointer'} `}
          >
            English
          </a>
        </li>
        <li className="mx-2">
          <a
            onClick={updateLng('ar')}
            className={`${i18n.language === 'ar' ? 'text-primary ' : 'hover:opacity-60 cursor-pointer'} font-arabic`}
          >
            العربية
          </a>
        </li>
      </ul>
    </div>
  );
};
